import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero-container" style={{ height: "100vh" }}>
      <div className="hero-content-wrapper">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
          style={{
            position: "relative",
            width: "100%",
            textAlign: "center",
            overflow: "visible",
          }}
        >
          <h1 className="hero-title">Kynetic</h1>
          <h2 className="hero-subtitle">Marketing in Motion</h2>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
